// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-Row {\n  line-height: 1px;\n}\n.x-Row > * {\n  line-height: 1px;\n  margin: 3px;\n  padding: 5px 3px;\n}\n", "",{"version":3,"sources":["webpack://./modules/ui/components/Row.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAEA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAAF","sourcesContent":[".root {\n  line-height: 1px;\n}\n\n.root > * {\n  line-height: 1px;\n  margin: 3px;\n  padding: 5px 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "x-Row"
};
export default ___CSS_LOADER_EXPORT___;
